import type { ImportTemplateT } from '../types';

export const ChanneltalkImportTemplate: ImportTemplateT = {
  status: {
    enable: true,
    solved: [2, 'closed'],
    pending: [1, 'snoozed'],
    sovledOrPending: [3, 'closed or snoozed'],
  },
  bound: {
    enable: false,
    all: [1, 'All'],
    inbound: [2, 'Inbound only'],
    outbound: [3, 'Outbound only'],
  },
  tag: {
    enable: true,
    all: [1, 'All'],
    import: [2, 'Import only conversations with these tags'],
    doNotImport: [3, 'Do not import conversations with these tags'],
  },
};
